import Permissions from '@/constants/permissions';

export default {
    getMenu: function () {
        return [
            {
                name: 'Strona Główna',
                icon: 'DashboardIcon',
                component: 'home',
                visible: true
            },
            {
                name: 'Rodziny',
                icon: 'FamiliesIcon',
                visible: true,
                children: [
                    {
                        name: 'Nieprzypisane',
                        component: 'families-to-accept',
                        visible:
              this.permissions(Permissions.FAMILY_EDITION_LIST_VIEW) ||
              this.permissions(Permissions.ASSIGNED_FAMILY_EDITION_LIST_VIEW)
                    },
                    {
                        name: 'Do zatwierdzenia',
                        component: 'families-to-approval',
                        visible:
              this.permissions(Permissions.FAMILY_TO_ACCEPT_INTERNAL) ||
              this.permissions(Permissions.FAMILY_TO_ACCEPT_EXTERNAL)
                    },
                    {
                        name: 'Do decyzji',
                        component: 'families-to-decide',
                        visible: this.permissions(Permissions.FAMILY_EDITION_ADD)
                    },
                    {
                        name: 'Przypisane',
                        component: 'families-list',
                        label: 'AF_LENGTH',
                        visible: true
                    }
                ]
            },
            {
                name: 'Magazyny',
                icon: 'StoreIcon',
                component: 'warehouse-list',
                visible:
          this.permissions(Permissions.WAREHOUSE_REGIONAL_LIST_VIEW) ||
          this.permissions(Permissions.WAREHOUSE_SUPPORTING_LIST_VIEW)
            },
            {
                name: 'Obsługa ŚWR',
                icon: 'PlanerIcon',
                component: 'manage-swr',
                visible: this.permissions(Permissions.MANAGE_SWR)
            },
            {
                name: 'Paczkopedia',
                icon: 'GiftIcon',
                component: '',
                visible: false
            },
            {
                name: 'Archiwum',
                icon: 'ArchiveIcon',
                component: '',
                visible: false
            },
            {
                name: 'Statystyki',
                icon: 'StatsIcon',
                component: '',
                visible: false
            }
        ];
    },
    permissions: function (permissionName) {
        let permissions = JSON.parse(localStorage.getItem('permissions'));
        permissions = permissions || [];
        if (permissions.includes(permissionName) === true) {
            return true;
        }
        return false;
    }
};
